import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import user from "assets/icons/user.svg";
import edit from "assets/icons/edit.svg";
import back from "assets/icons/back-arrow.svg";
import emptyPage from "assets/icons/empty-page.svg";
import AccordionItem from "../components/Accordion";
import { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function Profile({ userData, t }) {
  const [accordionIsOpen, setAccordionIsOpen] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Profile component mounted", userData);
  }, [userData]);

  const goToEditProfile = () => {
    navigate("/dashboard/edit-profile");
  };

  return (
    <div className="profile-container">
      <div className="heading-container">
        <div className="back-container">
          <img
            src={back}
            alt="back"
            className="back-icon"
            onClick={() => {
              navigate("/dashboard/consultations");
            }}
          />
          <span className="profile-heading">{t("profile.my_profile")}</span>
        </div>
        <div className="edit-button" onClick={goToEditProfile}>
          <img src={edit} alt="edit" className="edit-icon" />
          <span className="edit-label">{t("profile.edit")}</span>
        </div>
        <img
          src={edit}
          alt="edit"
          className="edit-icon-mobile"
          onClick={goToEditProfile}
        />
      </div>
      <div className="patient-card">
        <div className="patient-header">
          <div className="patient-info">
            <div className="profile-avatar">
              <img src={user} alt="user" />
            </div>
            <span className="patient-name">
              {userData && `${userData.firstname} ${userData.lastname}`}
            </span>
          </div>
        </div>

        <div className="patient-info-section">
          <div className="info-block">
            <span className="info-label">{t("profile.date_of_birth")}</span>
            <span className="info-value">
              {moment(userData && userData.date_of_birth).format("DD-MM-YYYY")}
            </span>
          </div>

          <div className="info-block">
            <span className="info-label">{t("profile.gender")}</span>
            <span className="info-value capitalize-first-letter">
              {userData && userData.gender}
            </span>
          </div>

          <div className="info-block">
            <span className="info-label">{t("profile.email")}</span>
            <span className="info-value">
              {userData && userData.email ? userData.email : "-------"}
            </span>
          </div>

          <div className="info-block">
            <span className="info-label">{t("profile.phone_number")}</span>
            <span className="info-value">
              {userData && userData.phonenumber}
            </span>
          </div>

          {/* <div className="info-block">
            <span className="info-label">Bank ID</span>
            <div className="verified-container">
              <span className="info-value">Verified</span>
              <img src={verified} alt="verified" className="verified-icon" />
            </div>
          </div> */}

          <div className="info-block">
            <span className="info-label">SSN</span>
            <span className="info-value">
              {userData && userData.client_ssn}
            </span>
          </div>
        </div>
      </div>

      <div className="med-history-container">
        <AccordionItem
          isOpen={accordionIsOpen}
          onClick={() => setAccordionIsOpen(!accordionIsOpen)}
          title="Medical History"
          className="med-history-accordion"
        >
          {userData.medical_info ? (
            <div className="med-history-content">
              <div className="med-history-item">
                <span className="medical-question">
                  {t("profile.have_allergies")}
                </span>
                <span className="medical-answer">
                  {userData.medical_info.has_allergies === 0 ? "No" : "Yes"}
                </span>
              </div>
              {userData.medical_info.has_allergies === 1 && (
                <div className="med-history-item">
                  <span className="medical-question">
                    {t("profile.describe_allergies")}
                  </span>

                  <span className="medical-answer">
                    {userData.medical_info.allergies}
                  </span>
                </div>
              )}
              <div className="med-history-item">
                <span className="medical-question">
                  {t("profile.have_medicines")}
                </span>
                <span className="medical-answer">
                  {userData.medical_info.has_medication === 0 ? "No" : "Yes"}
                </span>
              </div>
              {userData.medical_info.has_medication === 1 && (
                <div className="med-history-item">
                  <span className="medical-question">
                    {t("profile.describe_medicines")}
                  </span>

                  <span className="medical-answer">
                    {userData.medical_info.medication}
                  </span>
                </div>
              )}
            </div>
          ) : (
            <div className="medical-info-empty-container">
              <img src={emptyPage} alt="empty" className="empty-page-img" />
              <span className="no-records-text">No records found</span>
              <span className="add-info-text">
                Add medical details by editing your profile
              </span>
            </div>
          )}
        </AccordionItem>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userData: state.auth.userData,
  };
}

export default connect(mapStateToProps, {})(withTranslation()(Profile));
